module.exports = __webpack_public_path__ + "static/media/478.a497fb90.webp";